import _ from 'underscore';

import assert from 'app/scripts/lib/assert';

import { makeVisitor, visit } from './babble';

let visitor;

export function tryBabble(keyPath, args = {}, options = {}) {
  if (!visitor) {
    visitor = makeVisitor(
      (o) => o,
      function (key, substitutions, options = {}) {
        assert(
          Object.prototype.hasOwnProperty.call(substitutions, key),
          `Error translating: '${key}' was not found in the provided substitutions ${JSON.stringify(
            Object.keys(substitutions),
          )}`,
        );

        const value = substitutions[key];

        assert(
          typeof value === 'string',
          "I don't know how to convert values into strings. Please use a localized conversion function and pass me the string result.",
        );

        if (options.raw) {
          return value;
        }

        return _.escape(value);
      },
    );
  }

  return visit(window.__locale, keyPath, visitor, args, options)?.join('');
}
